import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

class ProductAPI {
  async getProductList(keyword= '' , pageNumber = '') {
    try {
      const { data } = await axios.get(`${apiUrl}/app/products${keyword}`, {
        params: {

          page: pageNumber
        }
      });
      return data;
    } catch (error) {
      throw error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message;
    }
  }

  async getProductDetails(productId) {
    try {
      const { data } = await axios.get(`${apiUrl}/app/products/${productId}`);
      console.log(data)
      return data;
    } catch (error) {
      throw error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message;
    }
  }

  async createProductReview(productId, review) {
    try {
      const token = JSON.parse(localStorage.getItem("userInfo")).token;
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(
        `${apiUrl}/app/products/${productId}/reviews/`,
        review,
        config
      );
      return data;
    } catch (error) {
      throw error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message;
    }
  }

  async getTopRatedProducts() {
    try {
      const { data } = await axios.get(`${apiUrl}/app/products/top/`);
      return data;
    } catch (error) {
      throw error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message;
    }
  }
}

const productAPI = new ProductAPI();

export default productAPI;